import {Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import listItems from 'flarum/common/helpers/listItems';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import AbstractFormPage from './AbstractFormPage';
import PageContainer from '../components/PageContainer';
import SubmissionListState from '../states/SubmissionListState';
import SubmissionSortDropdown from '../components/SubmissionSortDropdown';
import ExportModal from '../modals/ExportModal';
import FormEditHeader from '../components/FormEditHeader';
import Form from '../models/Form';
import {formulaireFormEdit, formulaireFormShow, formulaireSubmission} from '../routes';
import SearchInput from '../components/SearchInput';

const translationPrefix = 'kilowhat-formulaire.forum.submission-index.';

export default class SubmissionIndexPage extends AbstractFormPage {
    submissionList!: SubmissionListState

    oninit(vnode: Vnode) {
        super.oninit(vnode);

        this.submissionList = new SubmissionListState({
            q: 'form:' + m.route.param('id'),
        });
        this.submissionList.refresh();
    }

    content(form: Form) {
        return m(PageContainer, [
            m(FormEditHeader, {
                form,
                changeTab: (key: string) => {
                    app.cache.formulaireFormEditTab = key;
                    m.route.set(formulaireFormEdit(form));
                },
                isSubmissionPage: true,
            }),
            m('.FormulaireFilters', [
                m(SubmissionSortDropdown, {
                    sort: this.submissionList.params.sort,
                    onchange: (value: string) => {
                        this.submissionList.params.sort = value;
                        this.submissionList.refresh();
                    },
                }),
                app.forum.attribute('formulaireCanSearchSubmissions') ? m(SearchInput, {
                    initialValue: '',
                    onchange: (value: string) => {
                        this.submissionList.params.q = 'form:' + m.route.param('id') + ' ' + value;
                        this.submissionList.refresh();
                    },
                    placeholder: app.translator.trans(translationPrefix + 'search'),
                }) : null,
                form.type() === 'standalone' ? LinkButton.component({
                    className: 'Button FormulaireFilters--right',
                    href: formulaireFormShow(this.form),
                }, app.translator.trans(translationPrefix + 'form-show')) : null,
                //TODO: clear all, filters
                form.attribute('canExport') ? Button.component({
                    className: 'Button Button--primary' + (form.type() === 'standalone' ? '' : ' FormulaireFilters--right'),
                    onclick: () => {
                        app.modal.show(ExportModal, {
                            form: this.form,
                        });
                    },
                    icon: 'fas fa-file-export',
                }, app.translator.trans(translationPrefix + 'export')) : null,
            ]),
            this.list(this.submissionList),
        ]);
    }

    list(state: SubmissionListState) {
        let loading;

        if (state.loading) {
            loading = LoadingIndicator.component();
        } else if (state.moreResults) {
            loading = Button.component({
                className: 'Button',
                onclick: state.loadMore.bind(state),
            }, app.translator.trans(translationPrefix + 'load-more'));
        }

        if (state.submissions.length === 0 && !state.loading) {
            return Placeholder.component({
                text: app.translator.trans(translationPrefix + 'empty'),
            });
        }

        return m('div', [
            m('table.FormulaireDataTable', [
                m('thead', m('tr', [
                    m('th', app.translator.trans(translationPrefix + 'columns.date')),
                    m('th', app.translator.trans(translationPrefix + 'columns.user')),
                    m('th', app.translator.trans(translationPrefix + 'columns.actions')),
                ])),
                m('tbody', state.submissions.map(submission => {
                    const user = submission.user();
                    const badges = submission.badges().toArray();

                    return m('tr', [
                        m('td', [
                            submission.createdAt(),
                            badges.length ? m('ul.FormulaireDataTable-badges.badges', listItems(badges)) : null,
                        ]),
                        m('td', user ? [
                            avatar(user),
                            username(user),
                        ] : app.translator.trans(translationPrefix + 'guest')),
                        m('td', [
                            LinkButton.component({
                                className: 'Button',
                                href: formulaireSubmission(submission),
                            }, app.translator.trans(translationPrefix + 'show')),
                        ]),
                    ]);
                })),
            ]),
            loading,
        ]);
    }
}
